export default{
  brygady:[
    {
      brygada: 'Oddział Kmicica',
      data: '25.03.1943',
      link: '/historia/dzialalnosc_bojowa/Oddzial_Kmicica.pdf'
    },
    {
      brygada: '13. Brygada „Nietoperza”',
      data: '07.07.1943',
      link: '/historia/dzialalnosc_bojowa/13_Brygada.pdf'
    },
    {
      brygada: '5. Brygada „Łupaszki”.',
      data: '31.08.1943',
      link: '/historia/dzialalnosc_bojowa/5_Brygada.pdf'
    },
    {
      brygada: '6. Brygada „Tońka”, „Konara”.',
      data: '07.08.1943',
      link: '/historia/dzialalnosc_bojowa/6_Brygada.pdf'
    },
    {
      brygada: '3. Brygada „Szczerbca”.',
      data: '02.10.1943',
      link: '/historia/dzialalnosc_bojowa/3_Brygada.pdf'
    },
    {
      brygada: '1. Brygada "Juranda"',
      data: '',
      link: '/historia/dzialalnosc_bojowa/1_Brygada.pdf'
    },
    {
      brygada: '7. Brygada „Wilhelma”.',
      data: '02.02.1944',
      link: '/historia/dzialalnosc_bojowa/7_Brygada.pdf'
    },
    {
      brygada: '8. Brygada „Tura”.',
      data: '02.02.1944',
      link: '/historia/dzialalnosc_bojowa/8_Brygada.pdf'
    },
    {
      brygada: '9. Brygada „Małego’,„Gracza”',
      data: '02.02.1944',
      link: '/historia/dzialalnosc_bojowa/9_Brygada.pdf'
    },
    {
      brygada: '36. Brygada „Wujka”.',
      data: '02.02.1944',
      link: ''
    },
    {
      brygada: '4. Brygada „Ronina”.',
      data: '02.03.1944',
      link: '/historia/dzialalnosc_bojowa/4_Brygada.pdf'
    },
    {
      brygada: '12. Brygada „Cerbera”.',
      data: '10.03.1944',
      link: ''
    },
    {
      brygada: '24. Brygada „Wawrzeckiego”.',
      data: '12.03.1944',
      link: '/historia/dzialalnosc_bojowa/24_Brygada.pdf'
    },
    {
      brygada: '23. Brygada „Ostrogi”, „Światołdycza”.',
      data: '21.04.1944',
      link: '/historia/dzialalnosc_bojowa/23_Brygada.pdf'
    },
    {
      brygada: 'Oddział „Frycza”.',
      data: '23.04.1944',
      link: '/historia/dzialalnosc_bojowa/oddzial_kedywu_por_frycza.pdf'
    },
    {
      brygada: 'Oddział Rozpoznawczy Komendanta Okręgu',
      data: '15.05.1944',
      link: '/historia/dzialalnosc_bojowa/ORKO.pdf'
    },
    {
      brygada: '2. Brygada „Kaziuka”.',
      data: '02.07.1944',
      link: ''
    },
    {
      brygada: '19. Samoobrona „7-ka „Wilhelma”.',
      data: '15.10.1944',
      link: '/historia/dzialalnosc_bojowa/Oddzial_Samoobrony.pdf'
    }
  ]
}



// WEBPACK FOOTER //
// ./src/models/historia/dzialalnosc_bojowa.js